(function () {
  document.documentElement.classList.remove('no-js');

  // Re-render through Shopify so price, SKU and availability always match
  // the chosen variant, including market-specific money formatting.
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches('.product-form select[name="id"]') || !select.value) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.toString());
  });

  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var sheet = document.getElementById('MobileNav');

  if (header && toggle && sheet) {
    var links = sheet.querySelectorAll('a');

    function setMenu(open) {
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      sheet.setAttribute('data-open', open ? 'true' : 'false');
      sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
      links.forEach(function (link) {
        link.setAttribute('tabindex', open ? '0' : '-1');
      });
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setMenu(false);
      }
    });
  }
})();
